import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { Helmet, HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
// const title = "PromptMaker - Manage & generate infinite prompts -";
// const description =
//   "Freely manage and generate infinite prompt combination patterns. Input keywords manually. You can use for text2img and img2img.";
root.render(
  <React.StrictMode>
    {/* <HelmetProvider>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width" />
        <title>{title}</title>
        <script type="module">
          document.documentElement.classList.remove(`no-js`); document.documentElement.classList.add(`js`);
        </script>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://promptmaker.vercel.app/default-ogp.jpg" />
        <meta property="og:image:alt" content="Mainvisual of PromptMaker" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="og:url" content="https://promptmaker.vercel.app" />
        <link rel="canonical" href="https://promptmaker.vercel.app" />
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.webmanifest" />
        <meta name="theme-color" content="#0F172A" />
      </Helmet> */}
    <App />
    {/* </HelmetProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
